import React from 'react';
import { Box, Typography } from '@mui/material';

function Footer() {
  return (
    <Box
      sx={{
        width: '100%',
        py: 2,
        mt: 'auto', // Pushes the footer to the bottom
        backgroundColor: '#f2f0e4', // Match your app's background
        borderTop: '1px solid #e0e0e0',
        textAlign: 'center',
      }}
    >
      <Typography variant="body2" color="text.secondary">
        © 2025 YISWORK
      </Typography>
    </Box>
  );
}

export default Footer;
